import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiCallStarted } from "../middleware/api";
import DriverService from "src/_services/driverService";
import { ROLES, USER_ROLES } from "src/constants";


export const getAllDrivers = createAsyncThunk(
  'driver/getAllDrivers',
  async () => {
      const response = await DriverService.getAllDrivers();
      return response.data.body;
  }
);

const slice = createSlice({
  name: "drivers",
  initialState: {
    list: [],
    driversList:[],
    driversLoading: false,
    driverDetails: {},
    loading: false,
    lastFetch: null,
    rowCount: 0,
    pageSize: 0,
    page: 0
  },
  reducers: {
    driversRequested: (drivers, action) => {
      drivers.loading = true;
    },
    driversRequestSucceeded: (drivers, action) => {
      const { docs, totalDocs, limit, page } = action.payload.body;
      if (page && page > drivers.page) {
        drivers.list = [...drivers.list, ...docs];
        drivers.page = page;
        drivers.rowCount = totalDocs;
        drivers.pageSize = limit;
      } else {
        // TODO: to be used in DriverDetails Select List in Order, until converted to autoComplete
        drivers.list = docs;
        drivers.page = 1;
        drivers.rowCount = docs.length;
        drivers.pageSize = docs.length;
      }
      drivers.loading = false;
      drivers.lastFetch = Date.now();
    },
    driversRequestFailed: (drivers, _) => {
      drivers.loading = false;
    },
    driverDetailsRequestSucceded: (drivers, action) => {
      drivers.driverDetails = action.payload.body;
    },
    driverAdded: (drivers, action) => {
      drivers.list.push(action.payload);
    },
    driverRemoved: (drivers, action) => {
      const index = drivers.list.findIndex(
        (driver) => driver.id === action.payload.id
      );
      drivers.list.splice(index, 1);
    },
    pageChanged: (drivers, action) => {
      const { page: targetPage } = action.payload;
      drivers.page = targetPage;
    },
    clearDrivers: (drivers, action) => {
      drivers.list = [];
      drivers.page = 0;
      drivers.rowCount = 0;
      drivers.pageSize = 0;
      drivers.lastFetch = null;
      drivers.loading = false;
    },
    clearDriverDetails: (drivers, action) => {
      drivers.driverDetails = {};
    }
  },
  extraReducers: {
    [getAllDrivers.pending]: (state) => {
        state.driversLoading = true
    },
    [getAllDrivers.fulfilled]: (state, { payload }) => {
        state.driversList = [...payload]
        state.driversLoading = false
    },
    [getAllDrivers.rejected]: (state) => {
        state.driversLoading = false
    },
},
});

export const {
  driversRequested,
  driversRequestSucceeded,
  driversRequestFailed,
  driverDetailsRequestSucceded,
  driverAdded,
  driverRemoved,
  pageChanged,
  clearDrivers,
  clearDriverDetails
} = slice.actions;

// Action Creators
const apiEndpoints = {
  [ROLES.admin]: "/v1/admin-panel/driver",
  [ROLES.merchant]: "/v1/merchant-dashboard/driver",
  [ROLES.shippingCompany]: "/v1/merchant-dashboard/driver",
  [USER_ROLES.MERCHANT]: "/v1/merchant-dashboard/driver"
}

const commonEndpoint = "/v1/driver";

export const loadDrivers = (role, page) => (dispatch, getState) => {
  dispatch(
    apiCallStarted({
      url: `${commonEndpoint}?page=${page}`,
      onStart: driversRequested.type,
      onSuccess: driversRequestSucceeded.type,
      onError: driversRequestFailed.type,
    })
  );
};

export const loadDriverDetails = (role, id) => (dispatch, getState) => {
  dispatch(
    apiCallStarted({
      url: `${apiEndpoints[role]}/${id}`,
      // onStart: driversRequested.type,
      onSuccess: driverDetailsRequestSucceded.type,
      // onError: driversRequestFailed.type,
    })
  );
};

export default slice.reducer;
